<div class="video-container">
  <iframe 
    src="https://player.vimeo.com/video/947165906"
    width="100%" 
    height="100%" 
    frameborder="0"
    title="TOM: Tikkun Olam Makers"
    allow="autoplay; fullscreen; picture-in-picture"
    allowfullscreen>
  </iframe>
</div>